import { useContext } from "react";
import { AppContext } from "../App";
import { t } from "../i18n";

export const Header = ({ hours }) => {
	const { flow, route, data } = useContext(AppContext);

	return (
		<header
			className={
				"header" + (route === "selectDateTime" ? " finally" : "")
			}
		>
			<div className="header_wrapper">
				<div className="header_logos">
					<div className="header_ralarsa">
						<img
							className="header_img"
							src="resources/img/ralarsa.png"
							alt="Ralarsa"
						/>
					</div>
					<div className="separator"></div>
					{flow === "mapfre" ? (
						<div className="header_mapfre">
							<img
								className="header_img"
								src="resources/img/mapfre.png"
								alt="Mapfre"
							/>
						</div>
					) : flow === "caser" ? (
						<div className="header_caser">
							<img
								className="header_img"
								src="resources/img/caser.png"
								alt="Caser"
							/>
						</div>
					) : (
						flow === "allianz" && (
							<div className="header_allianz">
								<img
									className="header_img"
									src="resources/img/allianz.png"
									alt="Allianz Direct"
								/>
							</div>
						)
					)}
				</div>
				{route === "selectDateTime" && (
					<div className="header_content">
						<h2 className="header_h2">
							{data.damageArea === "repair" ? (
								<strong>
									{t(
										"Parece que tu caso sólo necesita de una reparación"
									)}
								</strong>
							) : (
								<strong>
									{t(
										"Este daño no es reparable, es necesario sustituir el vidrio"
									)}
								</strong>
							)}
						</h2>
						{hours?.type === "bookingExpress" &&
							data.damageArea === "replacement" && (
								<p className="header_p">
									{t(
										"Con los datos que nos has facilitado trataremos de tener el recambio listo en el taller."
									)}
								</p>
							)}
						{(!hours || hours?.type === "normal") &&
							(data.damageArea === "repair" ? (
								<p className="header_p">
									{t(
										"Reparamos tu luna en menos de 30 minutos. Elige fecha y hora."
									)}
								</p>
							) : (
								<p className="header_p">
									{t(
										"Con los datos que nos has facilitado trataremos de tener el recambio listo en el taller."
									)}
								</p>
							))}
					</div>
				)}
				{route === "loader" && (
					<div className="header_content">
						<img
							className="header_content_img"
							src="resources/img/confirm.png"
							alt="Reserva confirmada"
						/>
						<h2 className="header_h2 confirm_booking">
							{t("¡Gracias por tu reserva!")}
						</h2>
					</div>
				)}
			</div>
		</header>
	);
};
